import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-heading text-xl text-background-50">
              CSSBuy Spreadsheet
            </Link>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              {t('footerDisclaimerText')}
            </p>
          </div>

          {/* Guides */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              {t('footerGuides')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/cssbuy-spreadsheet" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerSpreadsheet')}
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-review" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerReview')}
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-shipping" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerShippingGuide')}
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-qc" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerQCGuide')}
                </Link>
              </li>
              <li>
                <Link to="/cssbuy-guide" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('navGuide')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              {t('footerCategories')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('catShoes')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('catHoodies')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('catTshirts')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('catJackets')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-915/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('catPants')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              {t('footerLegal')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerAbout')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerContact')}
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerDisclaimer')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                  {t('footerPrivacy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-8 border-t border-secondary-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-secondary-400">
              {t('footerCopyright')}
            </p>
            <div className="flex gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-400 hover:text-background-50 transition-colors">
                kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}